import { render, staticRenderFns } from "./recruitAssessment.vue?vue&type=template&id=0470643a&scoped=true"
import script from "./recruitAssessment.vue?vue&type=script&lang=js"
export * from "./recruitAssessment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0470643a",
  null
  
)

export default component.exports